import React, { useEffect, useRef, useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import SessionTimeoutDialog from 'components/SessionTimeoutDialog/SessionTimeoutDialog';
import { useAppDispatch } from 'app/hooks';
import { logOutRedirectsToLogin } from 'features/core/reducer';
import TagManager from 'react-gtm-module';

interface Props {
  timeOutValue: number;
  pageData: any;
}

const TIMEOUT_FOR_LOG_OUT = 60;

const SessionTimeout = ({ timeOutValue, pageData }: Props) => {
  const [showTimeoutModal, setShowTimeoutModal] = useState(false);
  const [timeoutCountdown, setTimeoutCountdown] = useState(TIMEOUT_FOR_LOG_OUT);
  const idleTimer = useRef(null);
  const dispatch = useAppDispatch();
  const handleLogOutRedirectsToLogin = () => {
    setShowTimeoutModal(false);
    dispatch(logOutRedirectsToLogin());
  };

  const handleContinue = () => {
    setShowTimeoutModal(false);
    setTimeoutCountdown(TIMEOUT_FOR_LOG_OUT);
    IdleTimer.start();
  };

  const onActive = () => {
    IdleTimer.start();
  };
  var tagManagerArgs: any;
  useEffect(() => {
    
      if (showTimeoutModal) {
        tagManagerArgs = {
          dataLayer: {
            event: 'session_expired',
          },
        };
        TagManager.dataLayer(tagManagerArgs);
      }
          
  }, [showTimeoutModal]);

  useEffect(() => {
    const logoutTimer = setInterval(() => {
      if (showTimeoutModal && timeoutCountdown > 0) {
        setTimeoutCountdown(timeoutCountdown - 1);
      }
      if (showTimeoutModal && timeoutCountdown === 0) {
        handleLogOutRedirectsToLogin();
      }
    }, 1000);
    return () => clearInterval(logoutTimer);
  }, [timeoutCountdown, showTimeoutModal]);

  const onIdle = () => {
    if (!showTimeoutModal) {
      setShowTimeoutModal(true);
    }
  };

  const IdleTimer = useIdleTimer({
    crossTab: true,
    onActive: onActive,
    onIdle: onIdle,
    debounce: 250,
    timeout: timeOutValue,
    ref: idleTimer,
  });

  return (
    <>
      {showTimeoutModal && (
        <SessionTimeoutDialog
          countdown={timeoutCountdown}
          onContinue={handleContinue}
          onClose={handleContinue}
          onLogout={handleLogOutRedirectsToLogin}
          pageData={pageData}
        />
      )}
    </>
  );
};

export default SessionTimeout;
